/**
 * Traditional Chinese (TWD) mock rows for the CSV-import review mockup. Shapes
 * mirror the app's import preview rows (see
 * web/src/screens/transactions/transaction-import/).
 */

/** @type {Array<import('../en/mock-import.js').MockImportRow>} */
export const MOCK_IMPORT_ROWS_ZH_TW = [
	{ date: '2026-07-30', type: 'Withdrawal', amount: 12000, description: '便利商店', included: true, errors: [], isDuplicate: false },
	{ date: '2026-07-29', type: 'Purchase', amount: 4800, description: '咖啡店', included: true, errors: [], isDuplicate: false },
	{ date: '2026-07-25', type: 'Deposit', amount: 350000, description: '薪水', included: true, errors: [], isDuplicate: false },
	{ date: '2026-07-22', type: 'Purchase', amount: 4830, description: '便利商店', included: false, errors: [], isDuplicate: true, reason: 'existing' },
	{ date: '2026-07-18', type: 'Reward Earned', amount: 4200, description: '航班獎勵', included: false, errors: [], isDuplicate: true, reason: 'existing-possible' },
	{ date: '2026-07-12', type: '', amount: 20000, description: 'ATM提款', included: false, errors: ['type'], isDuplicate: false },
];
